/* bx-cart-fix.js v9.0 — product-page utilities. NO CART CODE. (2026-08-29)

   WHY THE CART CODE IS GONE. Every version up to v8.4 owned the cart: it monkey-patched
   window.fetch and XMLHttpRequest site-wide (this file is loaded from layout/theme.liquid,
   so on every page), and re-rendered and opened the THEME drawer after any /cart/add. That
   made the cart un-switchable — there was no way to turn it off from the Shopify admin, and
   it silently outran the EGO Cart Upsell app (extension "opus-cart-drawer-cart-upsell"),
   which was installed, active and exposing window.opusOpen the whole time. Verified on the
   live theme: after discAddToCart the theme drawer went open/visible and EGO was never
   called.

   This file even carried the evidence that the same mistake had been made before — see the
   note in layout/theme.liquid about the v7 inline "BX Cart Fix" that "opened the Opus drawer
   blindly". Layering a second cart on top of an app's cart is how that happens.

   THE CART IS NOW THE STANDARD STACK. Whatever the merchant enables in the Shopify admin
   owns it: EGO while its app embed is on, the theme's own drawer when it is off. Nothing
   here touches window.fetch, XMLHttpRequest or cart-drawer.

   v9.1 (2026-08-31): ONE LINE OF BRIDGE, BECAUSE v9.0 LEFT A TRAP. v9.0 removed
   window.bxOpenCart on the assumption that discAddToCart's own fallback would then reach
   EGO safely. It does reach EGO — by SYNTHESISING A CLICK on #opus-sticky-cart — and that
   click bubbles into the theme's delegated cart handler as well, so BOTH carts opened, one
   behind the other. Measured on the live page: opusBtn.click() -> theme drawer open AND EGO
   open; window.opusOpen() -> EGO only; a plain /cart/add.js with no open call at all -> EGO
   only, because the app opens itself.

   So bxOpenCart is defined again, but it is not a cart: it is a two-line adapter that calls
   the cart app's own public API instead of faking a DOM event. discAddToCart probes
   window.bxOpenCart first, so defining it correctly here stops the click from ever
   happening. The permanent tidy-up is to delete the opusBtn.click() fallback from
   disc-hero.liquid and disc-bundle-selector.liquid; this adapter is what keeps the site
   correct until then, and it stays harmless afterwards.

   WHAT STAYS, AND WHY. Only things that would break product pages if removed:
     - site-wide CSS patches (hide the disabled Loox referral tab, hero review-line contrast
       on mobile, sold-out button styling, hide the back-in-stock float tab)
     - the #bx-atc-form submit interceptor, so a custom buy box never does a native form POST
     - the SOLD-OUT GUARD for bx buy boxes: bx-product-hero never checked availability, so a
       sold-out product showed an active Add to Cart that errored. The guard reads
       /products/{handle}.js and, when the selected variant is unavailable, turns the CTA
       into the single "notify me" trigger for the back-in-stock app (programmatic click on
       .gw-float-widget; verified 2026-07-17), or a plain disabled "Sold out" when that app
       is absent. It restores the original button when a purchasable variant is selected. */
(function () {
  if (window.__bxCartFixV8) return;
  window.__bxCartFixV8 = true;

  /* --- site-wide CSS patches --- */
  try {
    var css = [
      "#looxReferralsWidget,#looxReferrals,[id^='looxReferrals'],#loox-refer-a-friend,",
      "div[id*='loox-referral'],div[class*='loox-referral'],.loox-referrals,",
      "iframe[src*='loox.io'][src*='referr'],iframe[id*='looxReferral']{display:none!important;visibility:hidden!important;pointer-events:none!important}",
      "@media(max-width:860px){.mb .hrev{background:transparent!important;-webkit-backdrop-filter:none!important;backdrop-filter:none!important;border:0!important;border-radius:0!important;padding:0!important;color:#fff!important;font-size:13px!important;white-space:normal!important;overflow:visible!important;text-overflow:clip!important;text-shadow:0 1px 10px rgba(10,8,4,.65)}}",
      "button[data-bx-soldout='1']{opacity:.55!important;cursor:not-allowed!important;filter:saturate(.6)}",
      ".gw-float-widget{display:none!important}"
    ].join('');
    var st = document.createElement('style');
    st.id = 'bx-global-patches';
    st.textContent = css;
    (document.head || document.documentElement).appendChild(st);
  } catch (e) {}

  /* A) Cart-open adapter. NOT a cart — it owns no state, renders nothing and patches
     nothing. It exists so the landing page's discAddToCart calls the cart app's API rather
     than clicking a button, which is what opened two drawers at once. */
  window.bxOpenCart = function () {
    if (typeof window.opusOpen === 'function') {
      try { window.opusOpen(); return; } catch (e) {}
    }
    window.location.href = '/cart';
  };

  /* B) Form submit interceptor — safety net if #bx-atc-form ever submits natively. */
  function init() {
    var form = document.getElementById('bx-atc-form');
    if (!form) { setTimeout(init, 300); return; }
    if (form.__bxBound) return;
    form.__bxBound = true;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (window.bxAddToCart) window.bxAddToCart();
      return false;
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* C) Sold-out guard for bx buy boxes (bx-product-hero & friends). */
  function soldOutGuard() {
    if (!/^\/products\//.test(location.pathname)) return;
    var btn = document.getElementById('bx-atc-btn');
    if (!btn) { setTimeout(soldOutGuard, 400); return; }
    if (btn.__bxGuard) return;
    btn.__bxGuard = true;
    var handle = location.pathname.split('/products/')[1].split(/[\/?#]/)[0];
    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('http'); return r.json(); })
      .then(function (p) {
        var avail = {};
        (p.variants || []).forEach(function (v) { avail[String(v.id)] = !!v.available; });
        function openBxNotify(e) {
          if (e) { e.preventDefault(); e.stopPropagation(); }
          var gw = document.querySelector('.gw-float-widget');
          if (gw) gw.click();
          return false;
        }
        function clearNotify(b) {
          if (b.dataset.bxNotify === '1') {
            delete b.dataset.bxNotify;
            if (b.__bxNotifySaved) { b.onclick = b.__bxOnclick || null; b.__bxNotifySaved = false; }
          }
        }
        function setState(b, ok) {
          if (!b) return;
          if (!ok) {
            if (!b.dataset.bxOrig) b.dataset.bxOrig = b.innerHTML;
            var gw = document.querySelector('.gw-float-widget');
            if (b.id === 'bx-atc-btn' && gw) {
              /* v8.3: sold-out CTA = single notify trigger (opens the app popup) */
              if (b.dataset.bxNotify === '1') return;
              b.disabled = false;
              b.removeAttribute('data-bx-soldout');
              b.dataset.bxNotify = '1';
              b.textContent = 'Sold out — notify me when it\'s back';
              if (!b.__bxNotifySaved) { b.__bxNotifySaved = true; b.__bxOnclick = b.onclick; }
              b.onclick = openBxNotify;
            } else {
              clearNotify(b);
              b.disabled = true;
              b.setAttribute('data-bx-soldout', '1');
              b.textContent = 'Sold out';
            }
          } else if (b.dataset.bxOrig) {
            clearNotify(b);
            b.disabled = false;
            b.removeAttribute('data-bx-soldout');
            b.innerHTML = b.dataset.bxOrig;
            delete b.dataset.bxOrig;
            if (window.bxUpdateDisplayPrice) { try { window.bxUpdateDisplayPrice(); } catch (e) {} }
          }
        }
        function apply() {
          var inp = document.getElementById('bx-variant-id');
          var vid = inp ? String(parseInt(inp.value || '0')) : '0';
          var ok;
          if (p.available === false) { ok = false; }
          else if (avail.hasOwnProperty(vid)) { ok = avail[vid]; }
          else { ok = true; }
          setState(document.getElementById('bx-atc-btn'), ok);
          setState(document.getElementById('bx-sticky-btn'), ok);
        }
        apply();
        /* variant switches update a hidden input value (no DOM events) — poll cheaply */
        setInterval(apply, 700);
      })
      .catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', soldOutGuard);
  else soldOutGuard();
})();
